// export const BASE_URL = 'https://edunix-api.beetronix.com/';
// export const BASE_URL = 'https://api.alnukhbeh-edu.com/'
// export const BASE_URL = 'https://syria-flowers.beetronix.com/'
// export const BASE_URL = 'https://api.mirror.edunixsystem.com/'
// export const BASE_URL = 'https://al-awdah.beetronix.com/'
// export const IMAGE_URL = 'https://al-awdah.beetronix.com/Files/logo.png'
// export const BASE_URL = 'https://api.alrowadinstitute.edunixsystem.com'
// export const BASE_URL = 'http://api.gelalshahbaa.edunixsystem.com/'
// export const IMAGE_URL = 'https://syrian-flowers-manager.beetronix.net/files/logo.png';
// export const IMAGE_URL = 'https://api.gelalshahbaa.edunixsystem.com/files/logo.png'

// export const BASE_URL = 'https://api.alhakem.edunixsystem.com'
// export const IMAGE_URL = 'https://api.alhakem.edunixsystem.com/files/logo.png'

// export const BASE_URL = 'https://api.alrowad-school.edunixsystem.com'
// export const IMAGE_URL = 'https://api.alrowad-school.edunixsystem.com/files/logo.png'

// export const BASE_URL = 'https://api.alawal.edunixsystem.com/';
// export const IMAGE_URL = 'https://api.alawal.edunixsystem.com/files/logo.png'

// export const BASE_URL = 'https://api.alawalschool.edunixsystem.com/'
// export const IMAGE_URL = 'https://api.alawalschool.edunixsystem.com/files/logo.png'

// export const  BASE_URL = 'https://api.sawa.edunixsystem.com/'
// export const IMAGE_URL = 'https://api.sawa.edunixsystem.com/files/logo.png'

// export const BASE_URL = 'https://api.aljenan.edunixsystem.com/'
// export const IMAGE_URL =  'https://api.aljenan.edunixsystem.com/files/logo.png'


// export const BASE_URL = 'https://api.mirror.edunixsystem.com/'
// export const IMAGE_URL =  'https://api.mirror.edunixsystem.com/files/logo.png'

// export const BASE_URL = 'https://api.almarah-school.edunixsystem.com/'
// export const IMAGE_URL =  'https://api.mirror.edunixsystem.com/files/logo.png'

// export const BASE_URL = 'https://api.al-qalaji.edunixsystem.com'
// export const IMAGE_URL = 'https://api.al-qalaji.edunixsystem.com/files/logo.png'

// export const BASE_URL = 'https://api.motherland.edunixsystem.com/'
// export const IMAGE_URL = 'https://api.motherland.edunixsystem.com/files/logo.png'

// export const BASE_URL = 'https://api.gelalshahbaa.edunixsystem.com/'
// export const IMAGE_URL = 'https://api.gelalshahbaa.edunixsystem.com/files/logo.png'

// export const BASE_URL = 'https://api.alrowad-school.edunixsystem.com/'
// export const IMAGE_URL = 'https://api.alrowad-school.edunixsystem.com/files/logo.png'

// export const BASE_URL = 'https://api.aljenan.edunixsystem.com'
// export const IMAGE_URL = 'https://api.aljenan.edunixsystem.com/files/logo.png'

// export const BASE_URL = 'https://api.rowadalmustakbal.edunixsystem.com/'
// export const IMAGE_URL = 'https://api.rowadalmustakbal.edunixsystem.com/files/logo.png'

// export const BASE_URL = 'https://api.albayan-schools.com/'
// export const IMAGE_URL = 'https://api.albayan-schools.com/files/logo.png'

export const BASE_URL = 'https://api.shamsalassil.edunixsystem.com/'
export const IMAGE_URL = 'https://api.shamsalassil.edunixsystem.com/files/logo.png'

// export  const  BASE_URL = 'https://api.alawal.edunixsystem.com/'
// export const IMAGE_URL = 'https://api.alawal.edunixsystem.com/files/logo.png'

// export const BASE_URL = 'https://api.sawa.edunixsystem.com/'
// export const IMAGE_URL = 'https://api.sawa.edunixsystem.com/files/logo.png'

// export const BASE_URL = 'https://api.motherland.edunixsystem.com/'
// export const IMAGE_URL = 'https://api.motherland.edunixsystem.com/files/logo.png'

export const VERSION = '5.0.2';

// api.ags-sy.com
// api.ags-sy.com/files/logo.png

